import { Timestamp } from "api/firebase";
import {
  IExhibitorCompany,
  IExhibitorPair,
  IExhibitorUserConnection,
  IStand,
  ShowUnitSystem,
} from "@evennt-tech/api-v2-core";
import { SortDirection } from "./list";

export type Task = {
  value: any;
  id: string;
};
export enum CustomReportTasksColumnsType {
  task = "task",
  multitask = "multitask",
}

export type CustomReportFileLink = {
  name: string;
  url: string;
};

export type CustomReportSubtaskItem = {
  id: string;
  value: string;
  fileLinks?: CustomReportFileLink[];
  shouldIgnoreCopiesAndShowParent?: boolean;
};
export type CustomReportTasksItem =
  | {
      // `id` and `taskUuid` are two ids for the same task; callers match
      // `column.columnId` against either for config compatibility.
      id: string;
      taskUuid?: string;
      type: CustomReportTasksColumnsType.task;
      value: string;
      fileLinks?: CustomReportFileLink[];
      subtasks: undefined;
    }
  | {
      id: string;
      taskUuid?: string;
      type: CustomReportTasksColumnsType.multitask;
      value: string;
      fileLinks?: CustomReportFileLink[];
      subtasks: CustomReportSubtaskItem[];
    };

export type CustomReportSubTasks = {
  columns: CustomReportSubtaskItem[];
  status: CustomReportSubtaskItem[];
  submission: CustomReportSubtaskItem[];
  response: CustomReportSubtaskItem[];
  responseId: CustomReportSubtaskItem[];
};

export type CustomReportTasks = {
  columns: CustomReportTasksItem[];
  status: CustomReportTasksItem[];
  submission: CustomReportTasksItem[];
  response: CustomReportTasksItem[];
  responseId: CustomReportTasksItem[];
};

export type CustomField = {
  value: any;
  id: string;
  name?: string;
  type?: string;
  fileLinks?: CustomReportFileLink[];
};

export type CustomFields = {
  columns: Record<number, CustomField>;
  answers: Record<number, CustomField>;
};

export type Filter = {
  label: string;
  checked: boolean;
  type?: string;
  id?: string;
  operator?: string;
  value?: string | string[];
  values?: string[];
  defaultValues?: string[];
  fieldType?: string;
  field?: string;
};

export type FilterData = {
  title: string;
  total: number;
  filters: Filter[];
};

export type FilterPathWithValue = {
  field: string;
  value: string;
};

export type Filters = {
  [key: string]: FilterData | string;
};

export type ValueData = {
  title: string;
  total: number;
  checkboxes: CustomCheckbox[];
};

export type CustomCheckbox = {
  label: string;
  checked: boolean;
  type?: string;
  id?: string;
  columnId: string;
};

export type BaseCustomValues = {
  companyInformation: ValueData;
  standInformation: ValueData;
  customFields: ValueData;
  userInformation: ValueData;
  tasks: ValueData;
};

export type defaultForm = {
  reportTitle: string;
  name: string;
};

export type Field = {
  name?: string;
  label: string;
  type: string;
  columnId?: string;
  taskType?: string;
};

export type Sheet = {
  sheetTitle: string;
  sheetData: BaseCustomValues;
  columnsOrder: Field[];
};

export type CustomReport = {
  id: string;
  title: string;
  sheets: Sheet[];
  filters?: Record<string, Filters>;
  jsonFeed?: CustomReportFeed;
};

// export type CustomReportExhibitor = ShowExhibitor & {
export type CustomReportExhibitor = {
  exhibitorPair: IExhibitorPair;
  company: IExhibitorCompany;
  // Wire shape names this `newStand` — keep it; renaming to `stand` breaks
  // every stand column on the Custom Reports page.
  newStand: IStand;
  primaryConnection: IExhibitorUserConnection;
  userConnection: IExhibitorUserConnection;
  status: string;
  tasks?: CustomReportTasks;
  customFields?: CustomFields;
  id: string;
  showId?: string;
  showUnitSystem?: ShowUnitSystem;
};

export type SearchParams = {
  limit?: string;
  page?: string;
  itemIdx?: string;
  status?: string;
  search?: string;
  sortDirection?: SortDirection;
  value?: string;
};

type CustomReportFeedBase = {
  isEnabled?: boolean;
  token: string;
  lastSyncedAt?: Timestamp;
};

export type CustomReportFeedSingleSheet = CustomReportFeedBase & {
  sheetId: string;
  includeAllSheets?: false;
};

export type CustomReportFeedAllSheets = CustomReportFeedBase & {
  includeAllSheets: true;
};

export type CustomReportFeed =
  | CustomReportFeedSingleSheet
  | CustomReportFeedAllSheets;
